import { useSelector, useDispatch } from 'react-redux';

import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage.js';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJGeneratePrivacySettings from '../view/FJGeneratePrivacySettings.jsx';

const FJGeneratePrivacySettingsContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();
    const privacyStatus = useSelector(state => state.textToImage.privacyStatus);

    const _onPrivacySettingChange = (value, callback) => {
        dispatch(FJActionTextToImage.setPrivacySettingAction(value));
        callback(true);
    };

    return <FJGeneratePrivacySettings privacyStatus={privacyStatus} onPrivacySettingChange={_onPrivacySettingChange} />;
};

export default FJGeneratePrivacySettingsContainer;
